export type Environment = "development" | "production";

export const environment: Environment = process.env.NODE_ENV === "development" ? "development" : "production";
